import * as React from "react";
import { getViewInfo } from "src/common/attrView";
import { onError } from "src/common/onError";
import { MakeLabelParams } from "../../../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../../../utils/getAttrLabelTreeData";
import styles from "./LinkExternal.module.less";

type PropsLinkView = {
  params: MakeLabelParams;
};

export const LinkExternal: React.FC<PropsLinkView> = ({ params }) => {
  const { attribute } = params;
  const values = getAttrLabelTreeData(
    params.attribute,
    params.labelTreeData,
  )?.labels;
  const viewInfo = getViewInfo(attribute.viewType);
  const ref = values?.[0];
  if (!ref) return null;
  const overflow = styles[viewInfo?.appearance?.view?.overflow || ""];
  let label = ref;
  try {
    label = decodeURIComponent(ref);
  } catch (e) {
    onError(e);
  }
  return (
    <div className={overflow} style={{ ...viewInfo?.styles }}>
      <a
        href={ref}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {label}
      </a>
    </div>
  );
};
